import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, AlertTriangle } from "lucide-react";

/**
 * Standard risk disclaimer shown sitewide via <FooterDisclaimer />.
 * Industry-standard copy for retail-trading education apps.
 */
export default function FooterDisclaimer() {
  return (
    <footer
      data-testid="footer-disclaimer"
      className="border-t border-[#EAE6E1] dark:border-[#2A3340] bg-[#F9F8F6] dark:bg-[#0D1117] mt-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12 py-8 md:py-10 space-y-6">
        <div className="grid md:grid-cols-[1fr_auto] gap-6 items-start">
          <div className="text-xs text-[#6B7068] dark:text-[#8B949E] leading-relaxed max-w-3xl">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle className="w-3.5 h-3.5 text-[#D18E63]" strokeWidth={2} />
              <span className="text-[10px] uppercase tracking-[0.25em] font-semibold text-[#D18E63]">
                Risk disclosure
              </span>
            </div>
            <p>
              UpTick is an educational tool. Nothing on this site is investment, tax, legal, or financial advice.
              Market data may be delayed or inaccurate. All charts, AI explanations, signals, and "paper trading"
              results are for learning purposes only. Past performance does not guarantee future returns. Trading
              real securities and crypto involves substantial risk of loss — never trade with money you can't afford
              to lose, and always do your own research before making any financial decision.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs">
            <Link to="/legal/terms" className="text-[#6B7068] dark:text-[#8B949E] hover:text-[#2A2F2B] dark:hover:text-[#E6EDF3] transition-soft" data-testid="footer-link-terms">
              Terms
            </Link>
            <Link to="/legal/privacy" className="text-[#6B7068] dark:text-[#8B949E] hover:text-[#2A2F2B] dark:hover:text-[#E6EDF3] transition-soft" data-testid="footer-link-privacy">
              Privacy
            </Link>
            <Link to="/legal/risk" className="text-[#6B7068] dark:text-[#8B949E] hover:text-[#2A2F2B] dark:hover:text-[#E6EDF3] transition-soft" data-testid="footer-link-risk">
              Risk Disclosure
            </Link>
          </div>
        </div>
        <div className="flex items-center justify-between text-[11px] text-[#6B7068] dark:text-[#8B949E] pt-4 border-t border-[#EAE6E1]/60 dark:border-[#2A3340]/60">
          <span>© {new Date().getFullYear()} UpTick · Dynamic Market Trading</span>
          <span className="inline-flex items-center gap-1.5">
            <ShieldAlert className="w-3 h-3" /> No funds custody · Paper trading only
          </span>
        </div>
      </div>
    </footer>
  );
}
